let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("69Rua")).then(() => parcelRequire('bz8E8'));